const collator = new Intl.Collator('ru', { sensitivity: 'base', numeric: true });

export function compareFonotekaPackName(a: string, b: string): number {
  return collator.compare(a, b);
}

export function compareFonotekaTrackName(a: string, b: string): number {
  return collator.compare(a, b);
}

export function compareFonotekaPacks<T extends { id: string; name: string }>(a: T, b: T): number {
  return compareFonotekaPackName(a.name, b.name) || a.id.localeCompare(b.id);
}

export function compareFonotekaTracks<T extends { id: string; file_name: string }>(a: T, b: T): number {
  return compareFonotekaTrackName(a.file_name, b.file_name) || a.id.localeCompare(b.id);
}
